import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import AssigneeOptionContainer from './AssigneeOptionContainer';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const UnassignButtonOption = ({
  currentAssigneeId,
  onClick
}) => /*#__PURE__*/_jsx(Flex, {
  justifyContent: "end",
  paddingBlockEnd: "100",
  children: /*#__PURE__*/_jsx(AssigneeOptionContainer, {
    children: /*#__PURE__*/_jsx(Button, {
      "data-test-id": "reassignment-dropdown-unassign_button",
      use: "tertiary-light",
      size: "extra-small",
      disabled: currentAssigneeId === null,
      onClick: onClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.reassignment.unassignUserLabel"
      })
    })
  })
});
UnassignButtonOption.displayName = 'UnassignButtonOption';
export default UnassignButtonOption;